// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'semantic-ui-react';
import _ from 'lodash';
// local
// css
import './Reports.css';
// views
import Page from 'app/ui/pages/Page';
import DatePicker from 'app/ui/commons/datepicker/DatePicker';
import DropdownSupplier from 'app/ui/commons/DropdownSupplier';
import DropdownPatient from 'app/ui/commons/DropdownPatient';
import CustomDropdown from 'app/ui/commons/CustomDropdown';
import ReportPatient from './ReportPatient';
import ReportGeneral from './ReportGeneral';
import ReportSupplier from './ReportSupplier';
import ReportChangePatient from './ReportChangePatient';
import ReportChangeSupplier from './ReportChangeSupplier';
import ReportChanges from './ReportChages';
import ReportPrescription from './ReportPrescription';
import ReportDailyConsumption from './ReportDailyConsumption';
// lib
import { isFormValid } from 'app/lib/formHelper';
import { utcTime } from 'app/lib/helper';
// actions
import * as ReportActions from 'app/redux/actions/report';
// consts
import { STATUS as PATIENT_STATUS } from 'salvus-shared/consts/patient';

const REPORT_TYPE = {
    PATIENT: 1,
    SUPPLIER: 2,
    GENERAL: 3,
    CHANGE_PATIENT: 4,
    CHANGE_SUPPLIER: 5,
    CHANGE_GENERAL: 6,
    PRESCRIPTION: 7,
    DAILY: 8,
};

const REPORT_TYPE_FILTER = {
    REPLACMENT: 1,
    CYLINDER_CHANGE: 2,
    PRESCRIPTION: 3,
    DAILY: 4,
};

/* const reportTypeOptions = [
    { key: 1, text: 'Paciente', value: REPORT_TYPE.PATIENT },
    { key: 2, text: 'Fornecedor', value: REPORT_TYPE.SUPPLIER },
    { key: 3, text: 'Geral', value: REPORT_TYPE.GENERAL },
    { key: 4, text: 'Trocas Cilindros Paciente', value: REPORT_TYPE.CHANGE_PATIENT },
    { key: 5, text: 'Trocas Cilindros Fornecedor', value: REPORT_TYPE.CHANGE_SUPPLIER },
    { key: 6, text: 'Troca Cilindros Geral', value: REPORT_TYPE.CHANGE_GENERAL },
];*/

const reportTypeOptionsReplacement = [
    { key: 1, text: 'Paciente', value: REPORT_TYPE.PATIENT },
    { key: 2, text: 'Fornecedor', value: REPORT_TYPE.SUPPLIER },
    { key: 3, text: 'Geral', value: REPORT_TYPE.GENERAL },
];

const reportTypeOptionsCylinderChange = [
    { key: 1, text: 'Paciente', value: REPORT_TYPE.CHANGE_PATIENT },
    { key: 2, text: 'Fornecedor', value: REPORT_TYPE.CHANGE_SUPPLIER },
    { key: 3, text: 'Geral', value: REPORT_TYPE.CHANGE_GENERAL },
];

const reportTypeOptionsPrescription = [
    { key: 1, text: 'Paciente', value: REPORT_TYPE.PRESCRIPTION },
];

const reportTypeOptionsDaily = [
    { key: 1, text: 'Paciente', value: REPORT_TYPE.DAILY },
];

const reportTypeFilter = [
    { key: 1, text: 'Reposição', value: REPORT_TYPE_FILTER.REPLACMENT },
    { key: 2, text: 'Troca Cilindros', value: REPORT_TYPE_FILTER.CYLINDER_CHANGE },
    { key: 3, text: 'Prescrição', value: REPORT_TYPE_FILTER.PRESCRIPTION },
    { key: 4, text: 'Consumo Diário', value: REPORT_TYPE_FILTER.DAILY },
];

const DropdDownReportFilterTypeWrapper = ({ placeHolder, reportType, onChange, error }) => {
    if (!reportType || reportType === 0) {
        return null;
    } else if (reportType === REPORT_TYPE_FILTER.REPLACMENT) {
        return <CustomDropdown placeholder={placeHolder} options={reportTypeOptionsReplacement} onChange={onChange} error={error} selection />;
    } else if (reportType === REPORT_TYPE_FILTER.CYLINDER_CHANGE) {
        return <CustomDropdown placeholder={placeHolder} options={reportTypeOptionsCylinderChange} onChange={onChange} error={error} selection />;
    } else if (reportType === REPORT_TYPE_FILTER.PRESCRIPTION) {
        return <CustomDropdown placeholder={placeHolder} options={reportTypeOptionsPrescription} onChange={onChange} error={error} selection />;
    } else if (reportType === REPORT_TYPE_FILTER.DAILY) {
        return <CustomDropdown placeholder={placeHolder} options={reportTypeOptionsDaily} onChange={onChange} error={error} selection />;
    }
    return null;
};

DropdDownReportFilterTypeWrapper.propTypes = {
    placeHolder: PropTypes.string,
    reportType: PropTypes.number,
    onChange: PropTypes.func,
    error: PropTypes.bool,
};
/**
 * Wrapper method for the filter dropdown when changing the report type.
 */
const DropdownReportWrapper = ({ reportType, onChange, error }) => {   
    if (!reportType || reportType === REPORT_TYPE.GENERAL || reportType === REPORT_TYPE.CHANGE_GENERAL) {
        return null;
    }
    if (reportType === REPORT_TYPE.SUPPLIER || reportType === REPORT_TYPE.CHANGE_SUPPLIER) {
        return <DropdownSupplier placeholder="Selecione o fornecedor" onChange={onChange} error={error} />;
    }
    if (reportType === REPORT_TYPE.PATIENT || reportType === REPORT_TYPE.CHANGE_PATIENT || reportType === REPORT_TYPE.PRESCRIPTION || reportType === REPORT_TYPE.DAILY) {
        return (
            <DropdownPatient
                placeholder="Selecione o paciente"
                onChange={onChange}
                filter={[PATIENT_STATUS.INITIALIZED, PATIENT_STATUS.DEACTIVATED]}
                error={error}
            />
        );
    }
};

DropdownReportWrapper.propTypes = {
    reportType: PropTypes.number,
    onChange: PropTypes.func,
    error: PropTypes.bool,
};

/**
 * Wrapper method for rendering the report body.
 */
const ReportContentWrapper = ({ query, data, onClickSave, auth }) => {
    const { reportType } = query;
    if (!data) {
        return null;
    }
    return (
        <React.Fragment>
            {reportType === REPORT_TYPE.GENERAL ? <ReportGeneral auth={auth} data={data} onClickSave={onClickSave} /> : null}
            {reportType === REPORT_TYPE.SUPPLIER ? <ReportSupplier data={data} onClickSave={onClickSave} /> : null}
            {reportType === REPORT_TYPE.PATIENT ? <ReportPatient data={data} onClickSave={onClickSave} /> : null}
            {reportType === REPORT_TYPE.PRESCRIPTION ? <ReportPrescription data={data} /> : null}
            {reportType === REPORT_TYPE.DAILY ? <ReportDailyConsumption data={data} report={query} onClickSave={onClickSave} /> : null}
            {reportType === REPORT_TYPE.CHANGE_GENERAL ? <ReportChanges auth={auth} data={data} onClickSave={onClickSave} /> : null}
            {reportType === REPORT_TYPE.CHANGE_SUPPLIER ? <ReportChangeSupplier data={data} onClickSave={onClickSave} /> : null}
            {reportType === REPORT_TYPE.CHANGE_PATIENT ? <ReportChangePatient data={data} onClickSave={onClickSave} /> : null}
        </React.Fragment>
    );
};

ReportContentWrapper.propTypes = {
    loading: PropTypes.bool,
    query: PropTypes.object,
    data: PropTypes.object,
    onClickSave: PropTypes.func,
    auth: PropTypes.object,
};

class Reports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            form: this.initForm(),
            errors: {},
            typeReport: 0,
        };
    }

    componentWillUnmount = () => this.props.dispatch(ReportActions.reset());

    initForm = () => {
        return {
            dateFrom: null,
            dateTo: null,
            reportType: null,
            filter: null,
        };
    };

    validateForm(form, field) {
        const errors = {};

        if (!field || field === 'dateFrom' || field === 'dateTo') {
            const dateFrom = form.dateFrom;
            const dateTo = form.dateTo;
            if (_.isNil(dateFrom)) {
                errors['dateFrom'] = 'O campo DE é obrigatório.';
            } else if (utcTime(new Date(dateFrom)) > utcTime()) {
                errors['dateFrom'] = 'O campo DE não pode ser maior que hoje.';
            } else if (dateFrom > dateTo) {
                errors['dateFrom'] = 'O campo DE não pode ser maior que o ATÉ.';
            } else {
                errors['dateFrom'] = undefined;
            }
            if (_.isNil(dateTo)) {
                errors['dateTo'] = 'O campo ATÉ é obrigatório.';
            } else if (utcTime(new Date(dateTo)) > utcTime()) {
                errors['dateTo'] = 'O campo ATÉ não pode ser maior que hoje.';
            } else if (dateTo < dateFrom) {
                errors['dateTo'] = 'O campo DE não pode ser maior que o ATÉ.';
            } else {
                errors['dateTo'] = undefined;
            }
        }

        const reportType = form.reportType;
        if (!field || field === 'reportType') {
            if (!Object.values(REPORT_TYPE).includes(reportType)) {
                errors['reportType'] = 'O campo filtro é obrigatório.';
            } else {
                errors['reportType'] = undefined;
            }
        }

        if (!field || field === 'filter') {
            const filter = form.filter;
            if ((reportType === REPORT_TYPE.PATIENT || reportType === REPORT_TYPE.SUPPLIER) && _.isNil(filter)) {
                errors['filter'] = 'O campo filtro é obrigatório.';
            } else {
                errors['filter'] = undefined;
            }
        }

        return errors;
    }

    onChange = field => value => {
        let { form, errors } = this.state;
        _.set(form, field, value);
        const validation = this.validateForm(form, field);
        _.forIn(validation, function(value, key) {
            errors[key] = value;
        });
        this.setState({ form, errors });
    };

    hasError = field => !_.isEmpty(this.state.errors[field]);

    onChangeReportFilterType = (e, { value }) => {
        const { errors } = this.state;
        if ([1, 2, 3, 4].indexOf(value) === -1) {
            _.set(errors, 'reportTypeFilter', 'O valor não existe.');
            this.setState({ errors });
            return false;
        }
        this.setState({ typeReport: value });
    };

    onChangeReportType = (e, { value }) => {
        this.onChange('reportType')(value);
        let { form, errors } = this.state;
        _.set(form, 'filter', null);
        _.set(errors, 'filter', undefined);
        this.setState({ form, errors });
    };

    onChangeFilterValue = (e, { value }) => this.onChange('filter')(value);

    onClickGenerateReport = () => {
        // check if there is any error in the form
        const { form } = this.state;
        const errors = this.validateForm(form);
        if (!isFormValid(errors)) {
            this.setState({ errors });
            return;
        }
        const query = _.assign({}, form);
        // only update the report type from the query when the user submit
        switch (query.reportType) {
            case REPORT_TYPE.PATIENT:
                this.props.dispatch(ReportActions.loadReportByPatient(query));
                break;
            case REPORT_TYPE.SUPPLIER:
                this.props.dispatch(ReportActions.loadReportBySupplier(query));
                break;
            case REPORT_TYPE.CHANGE_PATIENT:
                this.props.dispatch(ReportActions.loadReportChangeByPatient(query));
                break;
            case REPORT_TYPE.CHANGE_SUPPLIER:
                this.props.dispatch(ReportActions.loadReportChangeBySupplier(query));
                break;
            case REPORT_TYPE.CHANGE_GENERAL:
                this.props.dispatch(ReportActions.loadReportChanges(query));
                break;
            case REPORT_TYPE.PRESCRIPTION:
                this.props.dispatch(ReportActions.loadReportPrescription(query));
                break;
            case REPORT_TYPE.DAILY:
                this.props.dispatch(ReportActions.loadReportDaily(query));
                break;
            default:
                this.props.dispatch(ReportActions.loadReportByGeneral(query));
                break;
        }
    };

    onClickSave = () => {
        const query = _.assign({}, this.state.form);
        // only update the report type from the query when the user submit
        switch (query.reportType) {
            case REPORT_TYPE.PATIENT:
                this.props.dispatch(ReportActions.downloadPDFByPatient(query));
                break;
            case REPORT_TYPE.SUPPLIER:
                this.props.dispatch(ReportActions.downloadPDFBySupplier(query));
                break;
            case REPORT_TYPE.CHANGE_PATIENT:
                this.props.dispatch(ReportActions.downloadPDFChangesByPatient(query));
                break;
            case REPORT_TYPE.CHANGE_SUPPLIER:
                this.props.dispatch(ReportActions.downloadPDFChangesBySupplier(query));
                break;
            case REPORT_TYPE.CHANGE_GENERAL:
                this.props.dispatch(ReportActions.downloadPDFChangesByGeneral(query));
                break;
            case REPORT_TYPE.DAILY:
                this.props.dispatch(ReportActions.downloadPDFDaily(query));
                break;
            default:
                this.props.dispatch(ReportActions.downloadPDFByGeneral(query));
                break;
        }
    };

    render() {
        const { loading, data, query } = this.props.report;
        return (
            <Page id="page-reports" loading={loading}>
                <div className="page-header">
                    <div className="page-title">RELATÓRIOS</div>
                </div>
                <div className="body">
                    <div className="body-header">
                        <div className="filters flex">
                            <div>Período</div>
                            <DatePicker onChange={this.onChange('dateFrom')} error={this.hasError('dateFrom')} />
                            <div>à</div>
                            <DatePicker onChange={this.onChange('dateTo')} error={this.hasError('dateTo')} />
                            <CustomDropdown
                                placeholder="Selecione o tipo do relatorio"
                                options={reportTypeFilter}
                                onChange={this.onChangeReportFilterType}
                                error={this.hasError('reportType')}
                                selection
                            />
                            <DropdDownReportFilterTypeWrapper
                                placeholder="Selecione o filtro"
                                reportType={this.state.typeReport}
                                onChange={this.onChangeReportType}
                                error={this.hasError('reportType')}
                                selection
                            />
                            <DropdownReportWrapper
                                reportType={this.state.form.reportType}
                                onChange={this.onChangeFilterValue}
                                error={this.hasError('filter')}
                            />
                        </div>
                        <Button onClick={this.onClickGenerateReport}>GERAR RELATÓRIO</Button>
                    </div>
                    <div className="content">
                        <ReportContentWrapper query={query} data={data} onClickSave={this.onClickSave} auth={this.props.auth} />
                    </div>
                </div>
            </Page>
        );
    }
}

Reports.propTypes = {
    auth: PropTypes.object,
    report: PropTypes.object,
    dispatch: PropTypes.func,
};

const mapStateToProps = state => ({
    auth: state.auth,
    report: state.report,
});
export default connect(mapStateToProps)(Reports);
